import { gql } from '@apollo/client';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const surfaceNodesUnlinkedSubscription = gql`
  subscription surfaceNodesUnlinked($surface: ID!, $user: ID!) {
    surfaceNodesUnlinked(surface: $surface, user: $user) {
      node {
        ...surfaceNodeUnionDetails
      }
    }
  }
  ${surfaceUnionFragment}
`;
